import EmailIcon from 'images/email icon.svg'
import InstagramIcon from 'images/instagram icon.svg'
import { FooterContainer } from './FooterStyles'

const Footer = () =>
  <FooterContainer>
    <div>
      ©{`${new Date().getFullYear()}`} <a href='https://bloomanddye.com' target='_blank' rel='noreferrer'>Bloom & Dye</a>. All rights reserved.
    </div>
    <a href='mailto:julie@juliebeeler.com'>
      <img src={EmailIcon} alt='email' />
    </a>
    <a href='https://www.instagram.com/mushroomcoloratlas' target='_blank' rel='noreferrer'>
      <img src={InstagramIcon} alt='instagram' />
    </a>
  </FooterContainer>

export default Footer
